module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-upload"
  }, [_c('el-upload', {
    ref: "upload",
    attrs: {
      "action": "http://",
      "http-request": _vm.handleUpload,
      "show-file-list": false,
      "with-credentials": true,
      "accept": _vm.acceptType
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('common-confirm', {
    staticClass: "common-upload-confirm",
    attrs: {
      "iconColor": "#e40030",
      "dialogVisiable": _vm.importValidErrorVisible,
      "confirm": function () { return _vm.importValidErrorVisible = false; },
      "appendToDialog": ""
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.importValidErrorVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.importValidErrorVisible = $event
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.importValidErrorMessage)
    }
  })]), _vm._v(" "), _c('common-confirm', {
    staticClass: "common-upload-confirm",
    attrs: {
      "dialogVisiable": _vm.importValidUpdateVisible,
      "confirm": _vm.importExcel,
      "appendToDialog": ""
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.importValidUpdateVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.importValidUpdateVisible = $event
      }
    }
  }, [_c('div', [_vm._v("有重复的记录，是否继续上传？")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1790751c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1790751c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CommonUpload.vue
// module id = 1552
// module chunks = 7